import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Phone, Chat, Email, Adb } from '@material-ui/icons';
import RadioTabs from '../RadioTabs/RadioTabs';
import { CHANNEL_TYPES } from '../../constants';

const FloatingTabs = props => {
  const { selectedChannelType, onTabChange } = props;
  const radioTabCommonClass =
    'channel_selection_tab font-bold text-base flex items-center py-4 pl-6';
  return (
    <RadioTabs className="channel_tabs flex-col w-48 absolute pin-t pin-l">
      <RadioTabs.Tab
        id="tab_phone"
        name="tab_phone"
        checked={selectedChannelType === CHANNEL_TYPES.PHONE}
        onChange={onTabChange}
        label={
          <Fragment>
            <Phone fontSize="small" className="mr-4" />
            <span className="tracking-wide">{CHANNEL_TYPES.PHONE}</span>
          </Fragment>
        }
        value={CHANNEL_TYPES.PHONE}
        className="text-center"
        labelClassName={cx(radioTabCommonClass, {
          selected_channel_tab: selectedChannelType === CHANNEL_TYPES.PHONE,
        })}
      />
      <RadioTabs.Tab
        id="tab_chat"
        name="tab_chat"
        checked={selectedChannelType === CHANNEL_TYPES.CHAT}
        onChange={onTabChange}
        label={
          <Fragment>
            <Chat fontSize="small" className="mr-4" />
            <span className="tracking-wide">{CHANNEL_TYPES.CHAT}</span>
          </Fragment>
        }
        value={CHANNEL_TYPES.CHAT}
        className="text-center"
        labelClassName={cx(radioTabCommonClass, {
          selected_channel_tab: selectedChannelType === CHANNEL_TYPES.CHAT,
        })}
      />
      <RadioTabs.Tab
        id="tab_rasa_chat"
        name="tab_rasa_chat"
        checked={selectedChannelType === CHANNEL_TYPES.RASA_CHAT}
        onChange={onTabChange}
        label={
          <Fragment>
            <Chat fontSize="small" className="mr-4" />
            <span className="tracking-wide">RASA CHAT</span>
          </Fragment>
        }
        value={CHANNEL_TYPES.RASA_CHAT}
        className="text-center"
        labelClassName={cx(radioTabCommonClass, {
          selected_channel_tab: selectedChannelType === CHANNEL_TYPES.RASA_CHAT,
        })}
      />
      <RadioTabs.Tab
        id="tab_chatbot"
        name="tab_chatbot"
        checked={selectedChannelType === CHANNEL_TYPES.CHATBOT}
        onChange={onTabChange}
        label={
          <Fragment>
            <Adb fontSize="small" className="mr-4" />
            <span className="tracking-wide">{CHANNEL_TYPES.CHATBOT}</span>
          </Fragment>
        }
        value={CHANNEL_TYPES.CHATBOT}
        className="text-center"
        labelClassName={cx(radioTabCommonClass, {
          selected_channel_tab: selectedChannelType === CHANNEL_TYPES.CHATBOT,
        })}
      />
      <RadioTabs.Tab
        id="tab_email"
        name="tab_email"
        checked={selectedChannelType === CHANNEL_TYPES.EMAIL}
        onChange={onTabChange}
        label={
          <Fragment>
            <Email fontSize="small" className="mr-4" />
            <span className="tracking-wide">{CHANNEL_TYPES.EMAIL}</span>
          </Fragment>
        }
        value={CHANNEL_TYPES.EMAIL}
        className="text-center"
        labelClassName={cx(radioTabCommonClass, {
          selected_channel_tab: selectedChannelType === CHANNEL_TYPES.EMAIL,
        })}
      />
    </RadioTabs>
  );
};

FloatingTabs.propTypes = {
  selectedChannelType: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default  React.memo(FloatingTabs);
